import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Button, Typography, useMediaQuery, useTheme} from "@mui/material";
import {PD_LG, PD_XLG, PD_XLG2} from "@/shared/dimens";
import {PromoSectionData, SiteTemplate} from "../../types";

const PROMO_BG = "#0D2918";

export function PromoSection(props: { data: PromoSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  const imagePane = <div style={{flex: 1, minWidth: 280, position: "relative"}}>
    <img
      src={props.data.imageUrl}
      style={{
        width: "100%",
        aspectRatio: 0.85,
        objectFit: "cover",
        objectPosition: "center top",
        borderRadius: 8,
        display: "block",
      }}/>
    <div style={{
      position: "absolute",
      inset: 0,
      borderRadius: 8,
      background: "linear-gradient(to right, rgba(13,41,24,0.4) 0%, transparent 50%)",
    }}/>
  </div>;

  const textPane = <StyledBoxColumn style={{
    flex: 1,
    minWidth: 280,
    justifyContent: "center",
    gap: PD_LG,
    padding: sm ? PD_XLG2 : PD_LG,
  }}>
    {props.data.eyebrow
      ? <Typography
        variant="overline"
        style={{letterSpacing: 2, fontWeight: "700", color: theme.palette.secondary.main}}>
        {props.data.eyebrow}
      </Typography>
      : null}
    <StyledHeadingVariant default_={2} style={{color: "white"}}>
      {props.data.title}
    </StyledHeadingVariant>
    {props.data.body
      ? <Typography style={{color: "rgba(255,255,255,0.65)", lineHeight: 1.8}}>
        {props.data.body}
      </Typography>
      : null}
    {props.data.link?.text
      ? <Button
        href={props.data.link.url}
        variant="contained"
        color="secondary"
        style={{alignSelf: "flex-start"}}>
        {props.data.link.text}
      </Button>
      : null}
  </StyledBoxColumn>;

  const imageLeft = !sm || props.data.imagePosition === "left";

  return <div style={{width: "100%", background: PROMO_BG}}>
    <SectionContainer>
      <div style={{display: "flex", flexWrap: "wrap", gap: PD_XLG, alignItems: "center"}}>
        {imageLeft ? <>{imagePane}{textPane}</> : <>{textPane}{imagePane}</>}
      </div>
    </SectionContainer>
  </div>;
}
